// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, CircularProgress, Box } from '@metarouter-private/mr-mui';

export default function UploadProgress({ fileCount }) {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? '' : prev + '.'));
    }, 500);

    return () => clearInterval(dotsInterval);
  }, []);

  return (
    <Stack spacing={3} alignItems="center">
      <Box display="flex" justifyContent="center" py={2}>
        <CircularProgress />
      </Box>
      <Typography variant="body1">
        Processing {fileCount} files
        <Box component="span" sx={{ display: 'inline-block', width: '1.5em', textAlign: 'left' }}>
          {dots}
        </Box>
      </Typography>
    </Stack>
  );
}

UploadProgress.propTypes = {
  fileCount: PropTypes.number.isRequired,
};
